import * as XLSX from "xlsx"
import { saveAs } from "file-saver"

const exportToExcel = (data, filename = "data.xlsx") => {
  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()

  // const columnCount = data[0].length // number of columns

  worksheet["!cols"] = Array(10).fill({ wch: 25 })

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1")

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  })

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })

  saveAs(blob, filename)
}

export default exportToExcel
